const Status = {
  INIT: 'init',
  PENDING: 'pending',
  SUCCESS: 'success',
  FAILURE: 'failure',
};

module.exports = Status;
